import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import CenterModal from "@ats/src/components/modals/CenterModal";
import Button from "@ats/src/components/shared/Button";
import { trackEvent } from "@shared/lib/posthog";

type Props = {
  onCancel: () => void;
  location: any;
  history: any;
};

function RestartSubscriptionModal(props: Props) {
  const handleViewPlans = () => {
    trackEvent("restart_subscription_view_plans_clicked");
    props.history.push({
      pathname: "/hire/settings/billing",
      state: { orginalPathname: props.location.pathname },
    });
    props.onCancel();
  };

  return (
    <CenterModal headerTitleText="Restart your subscription" onCancel={props.onCancel}>
      <>
        <Styled.Instructions>
          Your subscription is no longer active. To publish jobs, please restart your subscription.
        </Styled.Instructions>
        <Styled.ButtonContainer>
          <Button name="viewPlansButton" type="submit" onClick={handleViewPlans}>
            View plans
          </Button>
          <Button styleType="secondary" onClick={props.onCancel}>
            Cancel
          </Button>
        </Styled.ButtonContainer>
      </>
    </CenterModal>
  );
}

export default RestartSubscriptionModal;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Instructions = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: RestartSubscriptionModal_Instructions;
    ${[t.mb(5)]}

    a {
      ${t.text.medium}
    }

    a:hover {
      text-decoration: underline;
    }
  `;
});

Styled.ButtonContainer = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: RestartSubscriptionModal_ButtonContainer;
    display: flex;
    > * {
      ${t.mr(3)}

      &:last-of-type {
        ${t.mr(0)}
      }
    }
  `;
});
